import {
  languagesRef,
  systemsRef,
  countriesRef,
  citiesRef,
  referencesRef,
  attributeTypeRef,
  referenceSpecific
} from "@/api/references.api";

import {
  LANGUAGE_REFS,
  SYSTEM_REFS,
  COUNTRY_REFS,
  CITY_REFS,
  REFERENCE_REFS,
  ATTRIBUTE_TYPE_REFS,
  REFERENCE_SPECIFIC,
  REFERENCE_CLEAR
} from "../type";

const state = {
  languages: [],
  systems: [],
  countries: [],
  cities: [],
  references: [],
  attributeTypes: [],
  referenceCache: {}
};

const getters = {
  getReferenceSpecific: state => id => {
    return state.referenceCache[id];
  }
};

const actions = {
  async [LANGUAGE_REFS]({ commit }, lang) {
    try {
      const response = await languagesRef(lang);
      commit(LANGUAGE_REFS, response.data.languages);
      return response.status;
    } catch (err) {
      return err.response.status;
    }
  },
  async [SYSTEM_REFS]({ commit }, lang) {
    try {
      const response = await systemsRef(lang);
      commit(SYSTEM_REFS, response.data.systems);
      return response.status;
    } catch (err) {
      return err.response.status;
    }
  },
  async [COUNTRY_REFS]({ commit }, lang) {
    try {
      const response = await countriesRef(lang);
      commit(COUNTRY_REFS, response.data.countries);
      return response.status;
    } catch (err) {
      return err.response.status;
    }
  },
  async [CITY_REFS]({ commit }, lang) {
    try {
      const response = await citiesRef(lang);
      commit(CITY_REFS, response.data.cities);
      return response.status;
    } catch (err) {
      return err.response.status;
    }
  },
  async [REFERENCE_REFS]({ commit }, lang) {
    try {
      const response = await referencesRef(lang);
      commit(REFERENCE_REFS, response.data.references);
      return response.status;
    } catch (err) {
      return err.response.status;
    }
  },
  async [ATTRIBUTE_TYPE_REFS]({ commit }, lang) {
    try {
      const response = await attributeTypeRef(lang);
      commit(ATTRIBUTE_TYPE_REFS, response.data.attributeTypes);
      return response.status;
    } catch (err) {
      return err.response.status;
    }
  },
  async [REFERENCE_SPECIFIC]({ state, commit }, { id, lang }) {
    if (state.referenceCache[id] === undefined) {
      try {
        const response = await referenceSpecific(id, lang);
        commit(REFERENCE_SPECIFIC, {
          id,
          lang,
          data: response.data.reference
        });
        return response.status;
      } catch (err) {
        return err.response.status;
      }
    }
  }
};

const mutations = {
  [REFERENCE_CLEAR](state) {
    state.languages = [];
    state.systems = [];
    state.countries = [];
    state.cities = [];
    state.references = [];
    state.attributeTypes = [];
    state.referenceCache = {};
  },
  [LANGUAGE_REFS](state, refs) {
    state.languages = refs;
  },
  [SYSTEM_REFS](state, refs) {
    state.systems = refs;
  },
  [COUNTRY_REFS](state, refs) {
    state.countries = refs;
  },
  [CITY_REFS](state, refs) {
    state.cities = refs;
  },
  [REFERENCE_REFS](state, refs) {
    state.references = refs;
  },
  [ATTRIBUTE_TYPE_REFS](state, refs) {
    state.attributeTypes = refs;
  },
  [REFERENCE_SPECIFIC](state, content) {
    state.referenceCache = { ...state.referenceCache, [content.id]: content };
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
